import { useDispatch } from 'react-redux';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useModal } from '@/providers/modal';
import Notify from '@/components/Notification';
import { ModalCenterLayout } from '@/kit/Modal/layouts/center';
import { ModalSwipeLayout } from '@/kit/Modal/layouts/swipe';
import { useWindowSize } from '@/hooks/useWindowSize';
import { useDeleteUser } from '@/query/queries/user/useDeleteUser';
import { logoutUser } from '@/store/services/userServices';
import { MODAL_IDS } from '@/kit/Modal/keys';
import r from '@/kit/RoundButton/button.module.scss';
import s from './index.module.scss';

const id = MODAL_IDS.account_delete_confirm_modal;

export const AccountDeleteConfirmModal = () => {
  const { modalIds, closeModal } = useModal();
  const { isMobile } = useWindowSize();
  const { mutateAsync: deleteUser } = useDeleteUser();
  const { t } = useTranslation('profile');

  if (!modalIds[id]) return null;

  const onDelete = async () => {
    const res = await deleteUser();
    if (res?.success) {
      Notify.success({ text: t('delete_acc_c_modal.account_deleted') });
      logoutUser();
    }
  };

  const content = (
    <div className={classnames(s.modal)}>
      <div className="f-h2 f-500">
        {t('delete_acc_c_modal.confirm_account_deletion')}
      </div>
      <div className={classnames(s.content, 'f-body')}>
        {t('delete_acc_c_modal.are_you_sure')}
      </div>
      <div className={s.footer}>
        <button
          type="button"
          className={classnames(r.black_large, s.btn_cancel)}
          onClick={() => closeModal(id)}
        >
          {t('delete_acc_c_modal.no_keep_my_account')}
        </button>
        <button
          type="button"
          className={classnames(r.white_large, s.btn_confirm)}
          onClick={onDelete}
        >
          {t('delete_acc_c_modal.yes_delete_my_account')}
        </button>
      </div>
    </div>
  );

  return isMobile ? (
    <ModalSwipeLayout id={id} onClose={() => closeModal(id)} showClose>
      {content}
    </ModalSwipeLayout>
  ) : (
    <ModalCenterLayout id={id} onClose={() => closeModal(id)} showClose>
      {content}
    </ModalCenterLayout>
  );
};
